module.exports = new __parcel__URL__("valentines_picnic_level_1.07752e6e.png").toString();